// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3B1Ej","linksContainer":"Header_linksContainer__-6VB1"};